export const COMPANY = {
  legalName: "Impact Frontiers Inc.",
  brandName: "Actrium AI",
  addressLine1: "5th Floor, 1177 6th Ave",
  addressLine2: "New York, NY 10036, USA",
  email: "vlado@actrium.ai",
  ein: "86-3509877",
  delawareFileNumber: "4089521",
  delawareIncorporationDate: "2/7/2021",
  nysDosFileNumber: "5939763",
  nysForeignQualificationDate: "2/11/2021",
  legalDocuments: [
    {
      label: "Certificate of Incorporation",
      href: "/assets/legal/impact-frontiers-certificate-of-incorporation.pdf",
    },
    {
      label: "Certificate of Amendment",
      href: "/assets/legal/impact-frontiers-certificate-of-amendment-20240205.pdf",
    },
  ],
  team: [
    {
      name: "Chen Wang",
      role: "CEO",
      focus: "Technology",
    },
    {
      name: "Vladimir Kysucky",
      role: "Director",
      focus: "Business Development",
    },
  ],
};
